<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/b66GkD/tc-custom/9781631954641.jpg?1701061558732" alt="This image is the cover for the book Finding Sanctuary in the Midst of Alzheimer's"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finding Sanctuary in the Midst of Alzheimer's
      </h1>
      <p class="bookDescription body article font2">
        <i>Finding Sanctuary in the Midst of Alzheimer’s</i> is currently the only Bible study on the market for dementia caregivers and the communities that serve them.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Shulman
      </h2>
      
      <p class="authorDescription body article"><B>Elizabeth Shulman, D.Min., STNA</B> has 29 years of experience in both parish and healthcare ministry. Her devotions for caregivers have appeared in Guideposts’ Strength and Grace, and she frequently speaks to churches, retirement communities, and other community groups on dementia and caregiving. A spousal caregiver for 8 years, she now trains congregations to be more comfortable and confident in ministering to families impacted by dementia. Elizabeth’s presentations, Mary and Martha Caregiving and A New Pair of Glasses, inform audience members on the challenges of caregiving and offers hope to caregivers by providing new ways to reframe their experience. She and her husband, Leo, share 7 wonderful daughters and live near Cleveland, Ohio. To find out more, please visit her website: www.elizabethshulman.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df023360